import { OperationResult, RequestParameters } from '../types/apiTypes';
import { AddressItem, BlackWhiteListItem } from '../types/blackWhiteListItemType';
import api from './api';
import { buildUrlString, SearchParams } from './helpers';

class BlackWhiteListApi {
    static doAuthGetRequest = async <T>(url: string) => await api.doAuthGetRequestAsync<T>(`/BlackWhiteList/${url}`);
    static doAuthPostRequestAsync = async <T, R>(url: string, data?: T, parameters?: RequestParameters) => await api.doAuthPostRequestAsync<T, R>('/BlackWhiteList/' + url, data, parameters);

    static async findAddress(address: string) {
        const queryParams: SearchParams = {
            address,
        };
        const url = buildUrlString(queryParams, 'findAddress');
        return await this.doAuthGetRequest<OperationResult<AddressItem[]>>(url);
    }

    static async getBlackWhiteList() {
        const url = buildUrlString(null, 'getBlackWhiteList');
        return await this.doAuthGetRequest<OperationResult<BlackWhiteListItem[]>>(url);
    }

    static async saveBlackWhiteList(data: BlackWhiteListItem): Promise<string> {
        const url = buildUrlString(null, 'saveBlackWhiteList');
        return await this.doAuthPostRequestAsync<BlackWhiteListItem, string>(url, data);
    }

    static async addToBlackList(data: BlackWhiteListItem): Promise<boolean> {
        const url = buildUrlString(null, 'addToBlackWhiteList');
        return await this.doAuthPostRequestAsync<BlackWhiteListItem, boolean>(url, data);
    }

    static async addToWhiteList(data: BlackWhiteListItem): Promise<boolean> {
        const url = buildUrlString(null, 'addToBlackWhiteList');
        return await this.doAuthPostRequestAsync<BlackWhiteListItem, boolean>(url, data);
    }

    static async deleteFromBlackList(id: string): Promise<boolean> {
        const queryParams: SearchParams = {
            id,
        };
        const url = buildUrlString(queryParams, 'deleteFromBlackWhiteList');
        return await this.doAuthPostRequestAsync<string, boolean>(url, id);
    }

    static async toggleBlackList(id: string) {
        const queryParams: SearchParams = {
            id,
        };
        const url = buildUrlString(queryParams, 'toggleBlackList');
        return await this.doAuthPostRequestAsync<string, string>(url);
    }
}

export default BlackWhiteListApi;